<template>
  <div>
    <div class="nav-container" v-bind:class="{ 'nav-container--open': opened }">
      <nav role="navigation" class="nested-menu">
        <top-level-nav></top-level-nav>
        <p class="nested-menu__description">
          {{ description }}
        </p>
        <ul class="nested-menu__list">
          <router-link
            v-for="item in config"
            :key="item.slug()"
            v-bind:to="{ name: `${nav}.details`, params: { id: item.slug() } }"
            active-class="nested-menu__item--active"
            class="
              nested-menu__item
              nested-menu__item--global
              nested-menu__item--child
            "
            tag="li"
          >
            <span class="nested-menu__item-title">{{ item.title() }}</span>
            <span class="nested-menu__item-subtitle">{{
              item.subTitle()
            }}</span>
          </router-link>
        </ul>
        <a
            class="nav__find-your-site"
            href="https://investsurrey.ca/market-intelligence/site-selector-tool"
            target="_blank"
          >
            Find Your Site
          </a>
      </nav>
      <button
        class="nav-toggle"
        v-if="toggleActive"
        v-bind:class="{ 'nav-toggle--open': opened }"
        v-on:click="toggle()"
      ></button>
    </div>
    <button
      class="mobile-hamburger"
      v-if="toggleActive"
      v-bind:class="{ 'mobile-hamburger--open': opened }"
      v-on:click="toggle()"
    ></button>
  </div>
</template>
<script>
import TopLevelNav from '@/components/TopLevelNav';

export default {
  data() {
    return {
      nav: 'global',
    };
  },
  props: ['config', 'opened', 'toggleActive', 'description'],
  components: { TopLevelNav },
  methods: {
    toggle() {
      this.opened = !this.opened;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/GlobalNav.vue